import dynamic from 'next/dynamic'

import Button from './button'
import Error from './error'
import { Dropdown, FieldDropdown } from './field-dropdown'
import FieldInput from './field-input'
import FieldRadioButton from './field-radio-button'
import FieldSwitchToggle from './field-switch-toggle'
import Group from './group'
import Input from './input'
import Label from './label'
import MaskedInput from './masked-input'
import PasswordInput from './password-input'
import RadioButton from './radio-button'
import Row from './row'
import SwitchToggle from './switch-toggle'
import { FieldTextarea, Textarea } from './textarea'

const PhoneInput = dynamic(() => import('./phone-input'))

export {
  Dropdown,
  FieldDropdown,
  Input,
  Textarea,
  Button,
  Row,
  Label,
  Group,
  PhoneInput,
  PasswordInput,
  SwitchToggle,
  FieldInput,
  FieldTextarea,
  FieldRadioButton,
  RadioButton,
  FieldSwitchToggle,
  Error,
  MaskedInput
}
